export enum PurchaseOptionAWS {
  COMPUTE_SAVINGS_PLAN = "COMPUTE_SAVINGS_PLAN",
  EC2_INSTANCE_SAVINGS_PLAN = "EC2_INSTANCE_SAVINGS_PLAN",
  ON_DEMAND = "ON_DEMAND",
  SPOT_INSTANCE = "SPOT_INSTANCE",
}
